import { fromJS } from 'immutable';

export const initialState = fromJS({
    showLoyaltyInputOnPaymentStep: true,
    loyaltyNumber: ''
});


export const SET_LOYALTY_NUMBER = '@@storefront/SET_LOYALTY_NUMBER';


export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOYALTY_NUMBER:
            return state
                .set('loyaltyNumber', action.loyaltyNumber)
                .set('showLoyaltyInputOnPaymentStep', action.showLoyaltyInputOnPaymentStep);
        default:
    }
    return state;
}



export function setLoyaltyNumber(loyaltyNumber) {
    return {
        type: SET_LOYALTY_NUMBER,
        loyaltyNumber,
        showLoyaltyInputOnPaymentStep: !loyaltyNumber 
    };
}


export function resetLoyalty() {
    return setLoyaltyNumber('');
}
